import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useTranslation } from "../../../hooks/useTranslation";

// Generic FAQ infrastructure — any topic can use this to load a per-language Markdown
// content file instead of hardcoding prose in component/translation-key code. Files live
// in public/locales/faq/ (same static-file convention as public/locales/{lang}.json) so
// content can be edited without touching component code. Falls back to the English file
// if the current language's file is missing (not yet translated).
export const useFaqMarkdownContent = (basePath: string): UseQueryResult<string> => {
    const { currentLanguage } = useTranslation();

    return useQuery({
        queryKey: ["faq", "markdown-content", basePath, currentLanguage],
        queryFn: async () => {
            const response = await fetch(`${basePath}.${currentLanguage}.md`);
            if (response.ok) {
                return response.text();
            }

            const fallbackResponse = await fetch(`${basePath}.en.md`);
            return fallbackResponse.text();
        },
        staleTime: 15 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
    });
};
